<template>
  <div class="caifeng-item box-item" @click="toUrl(`/caifeng/detail?id=${itemData.id}`)">
    <div class="img-wrap">
      <el-image fit="cover" class="img" :src="itemData.img"></el-image>
      <span class="sta sta-1" v-if="showSta&&itemData.sta==1">报名中</span>
      <span class="sta sta-2" v-if="showSta&&itemData.sta==2">已成团</span>
      <span class="sta sta-3" v-if="showSta&&itemData.sta==3">已结束</span>
    </div>
    <div class="title">{{itemData.title}}</div>
    <div class="desc z-flex z-flex-end">报名截止:{{itemData.deadline}}</div>
  </div>
</template>

<script>
export default {
  name: "caifengItem",
  props: {
    itemData: {
      type:Object,
      default:()=>{},
    },
    showSta:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.img-wrap{
  position: relative;
  .sta{
    position: absolute;
    left: 0;
    top: 0;
    font-size: 14px;
    color:#fff;
    padding: 3px 6px;
    border-bottom-right-radius: 4px;
    &.sta-1{
      background:$colorGreen;
    }
    &.sta-2{
      background:$colorRed;
    }
    &.sta-3{
      background:#888;
    }
  }
}
</style>
